import React from 'react'
import { SocialLabels } from 'src/types'
import { Card, ContentTypography, ImageIcon, Link } from './styles'
import { useTranslation } from 'react-i18next'

export const MapSocial = ({ icon, name, linkEs, link }: SocialLabels) => {
    const { i18n } = useTranslation()
    return (
        <>
            {i18n.language === 'es' ? (
                <Card marginBottom={'xsmall'}>
                    <Link href={linkEs} target={'_blank'}>
                        <ImageIcon src={icon} alt={name} />
                        <ContentTypography
                            variant={'h3'}
                            fontSize={'small'}
                            fontWeight={400}
                        >
                            {name}
                        </ContentTypography>
                    </Link>
                </Card>
            ) : (
                <Card marginBottom={'xsmall'}>
                    <Link href={link} target={'_blank'}>
                        <ImageIcon src={icon} alt={name} />
                        <ContentTypography
                            variant={'h3'}
                            fontSize={'small'}
                            fontWeight={400}
                        >
                            {name}
                        </ContentTypography>
                    </Link>
                </Card>
            )}
        </>
    )
}
